function SectionHeader(props) {
  return <h3 className="text-warning">{props.children}</h3>
}

export default SectionHeader;
